import { useEffect, useState } from 'react';

import { hasAnyPermission, PERMISSIONS, type PermissionCode } from '@/lib/permissions';
import type { CurrentMembership } from '@/stores/church-store';
import {
  loadMembersDirectoryPreferences,
  persistMembersDirectoryPreferences,
} from '@/pages/people/members-directory-preferences';

const EXTENDED_PREVIEW_PERMISSIONS: PermissionCode[] = [
  PERMISSIONS.PEOPLE_VIEW_CONTACT,
  PERMISSIONS.PEOPLE_VIEW_SECONDARY,
];

export const canChooseExtendedMemberPreview = (
  membership: Pick<CurrentMembership, 'systemRole' | 'permissions'> | null | undefined,
): boolean => hasAnyPermission(membership, EXTENDED_PREVIEW_PERMISSIONS);

export const useMemberQuickViewPreviewMode = (churchId: string | null | undefined) => {
  const [extendedPreview, setExtendedPreview] = useState(
    () => loadMembersDirectoryPreferences(churchId ?? undefined).extendedPreview,
  );

  useEffect(() => {
    setExtendedPreview(loadMembersDirectoryPreferences(churchId ?? undefined).extendedPreview);
  }, [churchId]);

  useEffect(() => {
    persistMembersDirectoryPreferences(churchId ?? undefined, {
      ...loadMembersDirectoryPreferences(churchId ?? undefined),
      extendedPreview,
    });
  }, [churchId, extendedPreview]);

  return {
    extendedPreview,
    setExtendedPreview,
  };
};
